module.exports = __webpack_public_path__ + "img/20200220234654786.9f99bbb7.jpg";